import { MutationTree } from "vuex";
import {
  AssignmentEntityType,
  BulkAssignmentStep,
  BulkAssignmentEntity,
  IEntityBulkAssignmentState,
  IEntityEmployee,
} from "../types";
import { IPaginationMeta } from "@/core/interfaces/state/paginationMeta.interface";

const mutations: MutationTree<IEntityBulkAssignmentState> = {
  setWorkflowActive(state, isActive: boolean) {
    state.isWorkflowActive = isActive;
  },
  setCurrentStep(state, step: BulkAssignmentStep) {
    state.currentStep = step;
  },
  setEntityType(state, entityType: AssignmentEntityType | null) {
    state.entityType = entityType;
  },
  setEntity(state, entity: BulkAssignmentEntity | null) {
    state.entity = entity;
  },
  setOrganizationId(state, organizationId: string | null) {
    state.organizationId = organizationId;
  },
  setAssignedEmployees(state, employees: IEntityEmployee[]) {
    state.assignedEmployees = employees;
  },
  setEmployeesPaginationMeta(state, paginationMeta: IPaginationMeta | null) {
    state.employeesPaginationMeta = paginationMeta;
  },
  setEmployeesSearchQuery(state, searchQuery: string) {
    state.employeesSearchQuery = searchQuery;
  },
  setEmployeesPageNo(state, pageNo: number) {
    state.employeesPageNo = pageNo;
  },
  removeAssignedEmployees(state, userIds: string[]) {
    state.assignedEmployees = state.assignedEmployees.filter(
      (employee) => !userIds.includes(employee.user_id),
    );
  },
  setFetchingEmployees(state, isFetching: boolean) {
    state.isFetchingEmployees = isFetching;
  },
  setAssigning(state, isAssigning: boolean) {
    state.isAssigning = isAssigning;
  },
  setAssignmentOptions(
    state,
    options: IEntityBulkAssignmentState["assignmentOptions"],
  ) {
    state.assignmentOptions = options;
  },
  setFetchingAssignmentOptions(state, isFetching: boolean) {
    state.isFetchingAssignmentOptions = isFetching;
  },
  setLastSuccessfulAssignment(
    state,
    lastSuccessfulAssignment: IEntityBulkAssignmentState["lastSuccessfulAssignment"],
  ) {
    state.lastSuccessfulAssignment = lastSuccessfulAssignment;
  },
  resetBulkAssignmentState(state) {
    state.isWorkflowActive = false;
    state.currentStep = null;
    state.entityType = null;
    state.entity = null;
    state.organizationId = null;
    state.assignedEmployees = [];
    state.employeesPaginationMeta = null;
    state.employeesSearchQuery = "";
    state.employeesPageNo = 1;
    state.isFetchingEmployees = false;
    state.isAssigning = false;
    state.assignmentOptions = [];
    state.isFetchingAssignmentOptions = false;
    state.lastSuccessfulAssignment = null;
  },
};

export default mutations;
